/*
  Fall Scent pill (Asana 1219465269687306). Markup + styles live in
  snippets/bar-types-2026.liquid; shown to everyone on the Volumizing S&C set,
  shampoo bar and conditioner bar PDPs.

  Click Fall Scent -> pill active, own bar-type pill outlined, scent picker
  switched to Sweet Sandalwood, gallery pill + swatch ring +
  "Fall pick" tag after the scent name on.
  Picking any other scent, or clicking the own bar-type pill, turns it off;
  the own-pill click also puts back the scent that was picked before Fall.
  Picking Sweet Sandalwood from the swatches without the pill leaves it off.
*/
(function () {
  var container = document.querySelector('.bar-types-container');
  var pill = container && container.querySelector('.fall-scent-pill');
  if (!pill) return;

  var scent = pill.dataset.fallScent;
  var ownPill = container.querySelector('[aria-current="true"]');
  var active = false;
  var previousScent = null;

  function radioFor(value) {
    var radios = document.querySelectorAll('variant-picker input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) return radios[i];
    }
    return null;
  }

  function checkedScent() {
    var checked = document.querySelector('variant-picker input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  // Non-bubbling change, so the document listener below ignores it
  function selectRadio(radio) {
    if (!radio || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change'));
  }

  // variant-picker rewrites the scent label on every change, so the tag is
  // re-added after the switch and removed when Fall mode ends
  function setTag(on) {
    var title = document.querySelector('variant-picker .variant-picker__swatch-option__lable__title');
    if (!title) return;
    var tag = title.querySelector('.fall-scent-tag');
    if (on && !tag) {
      tag = document.createElement('span');
      tag.className = 'fall-scent-tag';
      tag.textContent = 'Fall pick';
      var name = title.firstElementChild;
      if (name) name.after(tag);
      else title.appendChild(tag);
    } else if (!on && tag) {
      tag.remove();
    }
  }

  // The selected pill is bold and the other one regular, so both get a min-width
  // at their bold size before the first toggle; otherwise the row shifts.
  var widthsLocked = false;
  function lockWidths() {
    if (widthsLocked) return;
    widthsLocked = true;
    [ownPill, pill].forEach(function (el) {
      if (!el) return;
      var weight = el.style.fontWeight;
      el.style.fontWeight = '700';
      var width = el.getBoundingClientRect().width;
      el.style.fontWeight = weight;
      el.style.minWidth = width + 'px';
      el.style.justifyContent = 'center';
    });
  }

  function galleryPills() {
    return document.querySelectorAll('.bar-type-pill');
  }

  function setActive(on) {
    if (on === active) return;
    active = on;
    container.classList.toggle('is-fall', on);
    document.body.classList.toggle('fall-scent-on', on);
    pill.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (ownPill) {
      if (on) ownPill.setAttribute('role', 'button');
      else ownPill.removeAttribute('role');
    }
    galleryPills().forEach(function (el) {
      var label = el.querySelector('span') || el;
      if (!el.dataset.fallOriginal) el.dataset.fallOriginal = label.textContent;
      label.textContent = on ? 'Fall Scent' : el.dataset.fallOriginal;
      el.classList.toggle('fall-scent-gallery-pill', on);
    });
  }

  pill.addEventListener('click', function () {
    var radio = radioFor(scent);
    if (!radio) return;
    if (!active) previousScent = checkedScent();
    lockWidths();
    setActive(true);
    selectRadio(radio);
    setTag(true);
  });

  if (ownPill) {
    ownPill.addEventListener('click', function () {
      if (!active) return;
      setActive(false);
      setTag(false);
      selectRadio(radioFor(previousScent));
    });
  }

  // Real swatch clicks bubble; leaving Sweet Sandalwood ends Fall mode
  document.addEventListener('change', function (event) {
    if (!active) return;
    var target = event.target;
    if (!target.matches || !target.matches('variant-picker input[type="radio"]')) return;
    if (target.value !== scent) setActive(false);
    else setTag(true);
  });
})();
